// project imports
import { MenuItem } from 'types/menu';

// assets
import { DashboardOutlined } from '@ant-design/icons';
import { PERMISSIONS } from 'constants/permissions';

// icons
const icons = {
  DashboardOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard: MenuItem = {
  id: 'group-dashboard',
  title: '', // No title for dashboard group
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'menu.dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
      // No permission required - everyone can access dashboard
    }
  ]
};

export default dashboard;
